var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Container, bind } from 'vue-class-state';
import { HistoryState } from './HistoryState';
import { CollectState } from './CollectState';
import { SubscribeState } from './SubscribeState';
import { CommonState } from './CommonState';
import { DomState } from './DomState';
import { BingeState } from './BingeState';
let StoreContainer = class StoreContainer {
};
StoreContainer = __decorate([
    Container({
        strict: true,
        providers: [
            bind('history').toClass(HistoryState),
            bind('collect').toClass(CollectState),
            bind('binge').toClass(BingeState),
            bind('subscribe').toClass(SubscribeState),
            bind('common').toClass(CommonState),
            bind('dom').toClass(DomState),
        ],
    })
], StoreContainer);
export default StoreContainer;
